export default "__VITE_ASSET__x7vzJ84H__"